<template>
  <div>
    <login-form />
  </div>
</template>

<script>
import LoginForm from "@/components/Common/LoginForm";

export default {
  name: "login",
  components: {
    LoginForm
  },
};
</script>
